<div class="container pt-2 pb-2">
  <div class="row">
    <div class="col-sm-12">
      <h3 class="text-center">
        <span class="highlight">Welcome to CAL Portal </span>
        <button class="btn-link text-uppercase float-end close" (click)="close()">&times;</button>
      </h3>
      <p class="mt-4">
        Click <b>Signup for Product under</b>
        <a [hidden]="calsDisabled" class="btn-link link link-1" routerLink="/products/equity"> Equity (Stock brokering),</a>
        <a class="btn-link link link-2" routerLink="/products/unit-trust-one-signup"> Unit Trusts</a>
        <span [hidden]="caltDisabled">or</span>
        <a [hidden]="caltDisabled" class="btn-link link link-3" routerLink="/unit/treasuries">Treasuries</a> to subscribe for the product

        <br />
        <button class="btn-cancel m-t text-center btn-sm btn-shadow me-2 float-end" (click)="close()" type="button">Close</button>
      </p>
    </div>
  </div>
</div>
